(function () {
  'use strict';

  angular.module('ringbaPortal').component('numberForm', {
    bindings: {
      onSave: '&',
      onDismiss: '&',
      currentNumber: '<'
    },
    controller: NumberFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/numbers/number-form.view.html'
  });

  function NumberFormController(
    $q,
    numberService,
    accountsService
  ) {
    'ngInject';

    const vm = this;
    vm.$onChanges = onChanges;
    vm.onSubmit = onSubmit;
    vm.cancel = cancel;

    function onChanges(changesObj) {
      if (changesObj.currentNumber && vm.currentNumber) {
        // Change reference of currentNumber to a new object,
        // so that it doesn't change the existing object used in the table
        vm.currentNumber = angular.copy(vm.currentNumber);
      }
    }

    function onSubmit() {
      return numberService.updateNumber(accountsService.currentAccountId, vm.currentNumber.id, vm.currentNumber ).then(function(num){
        return vm.onSave(num);
      });
    }

    function cancel() {

      vm.onDismiss({
        $event: {}
      });
    }


  }
})();
